<onyx-section heading="labels.openingHours">
  <div class="container">
    @if (type() === 'pointsOfInterest' && mode() === OnyxFormMode.EDIT) {
      <onyx-message intent="information">
        <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

        {{ `${I18N}.newHours` | translate }}
      </onyx-message>
    }

    <onyx-toggle
      [(checked)]="isAlwaysOpen"
      [label]="`${I18N}.alwaysOpen`"
    ></onyx-toggle>

    @let controls = form().controls;
    <form [formGroup]="form()">
      <onyx-form-group label="labels.weekday" [controls]="controls.weekday">
        <onyx-timepicker
          [formControl]="controls.weekday"
          [showTimeRange]="true"
          [showErrors]="false"
          [size]="32"
        ></onyx-timepicker>

        <onyx-suggestions
          [control]="controls.weekday"
          [suggestions]="TIME_RANGE_SUGGESTIONS"
        ></onyx-suggestions>
      </onyx-form-group>

      <div class="group">
        <onyx-timepicker
          [formControl]="controls.saturday"
          label="labels.saturday"
          [showTimeRange]="true"
          [size]="32"
        ></onyx-timepicker>

        <onyx-checkbox
          label="labels.closed"
          [(checked)]="isSaturdayClosed"
          [showRequired]="false"
        ></onyx-checkbox>
      </div>

      <div class="group">
        <onyx-timepicker
          [formControl]="controls.sunday"
          label="labels.sunday"
          [showTimeRange]="true"
          [size]="32"
        ></onyx-timepicker>

        <onyx-checkbox
          label="labels.closed"
          [(checked)]="isSundayClosed"
          [showRequired]="false"
        ></onyx-checkbox>
      </div>
    </form>
  </div>
</onyx-section>
